import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';

interface Service {
  id: string;
  icon: string;
  title: string;
  description: string;
  details: string[];
  price: string;
  duration?: string;
  image: string;
}

const services: Service[] = [
  {
    id: 'blocked-account',
    icon: 'ri-bank-card-line',
    title: 'Bloke Hesap',
    description: 'Almanya için zorunlu olan bloke hesap açılışında tam destek',
    details: [
      'Banka seçimi danışmanlığı (Fintiba, Deutsche Bank, Expatrio)',
      'Online başvuru desteği',
      'Belge hazırlama',
      'Para transferi rehberliği',
      'Hesap onay takibi',
      'Almanya\'da hesap açma işlemleri'
    ],
    price: '€300',
    duration: '1-2 hafta',
    image: 'https://public.readdy.ai/ai/img_res/d2e9e6149cd818e1599428fb9f729ad5.jpg',
  },
  {
    id: 'health-insurance',
    icon: 'ri-shield-check-line',
    title: 'Sağlık Sigortası',
    description: 'Öğrenciler için en uygun sağlık sigortası seçenekleri',
    details: [
      'Kamu ve özel sigorta karşılaştırması',
      'Yaş ve bütçeye uygun seçenekler',
      'Online başvuru desteği',
      'Sigorta belgesi temin',
      'Almanya\'da sigorta aktivasyonu',
      'Sigorta değişikliği danışmanlığı'
    ],
    price: '€200',
    duration: 'Anında',
    image: 'https://readdy.ai/api/search-image?query=health%20insurance%20concept%20with%20medical%20stethoscope%20insurance%20documents%20and%20health%20card%20on%20a%20clean%20desk%20professional%20healthcare%20setting%20warm%20lighting%20european%20medical%20system&width=600&height=400&seq=svc-sigorta-001&orientation=landscape',
  },
  {
    id: 'accommodation',
    icon: 'ri-home-4-line',
    title: 'İndirimli Konaklama Hizmeti',
    description: 'Almanya\'da güvenli ve uygun fiyatlı konaklama bulma',
    details: [
      'Öğrenci yurdu başvuruları (€400-800/ay)',
      'Öğrenci evi WG seçenekleri (€400-800/ay)',
      'Özel daire arama (€700-1200/ay)',
      'Kira sözleşmesi kontrolü',
      'İlk ay konaklama desteği',
      'Ev arkadaşı bulma yardımı'
    ],
    price: '€400 - €600',
    duration: '2-4 hafta',
    image: 'https://readdy.ai/api/search-image?query=cozy%20modern%20student%20apartment%20in%20berlin%20germany%20with%20minimalist%20furniture%20bright%20natural%20light%20city%20view%20from%20window%20comfortable%20living%20space%20warm%20tones%20european%20style%20interior&width=600&height=400&seq=svc-konak-001&orientation=landscape',
  },
  {
    id: 'airport-pickup',
    icon: 'ri-plane-line',
    title: 'Havalimanı Karşılama',
    description: 'Almanya\'ya vardığınızda güvenli transfer hizmeti',
    details: [
      'Havalimanından karşılama',
      'Konaklama yerine transfer',
      'İlk gün alışveriş desteği',
      'Şehir tanıtımı',
      'Acil durum iletişim',
      'İlk hafta danışmanlık'
    ],
    price: '€350',
    duration: '1 gün',
    image: 'https://readdy.ai/api/search-image?query=airport%20arrival%20hall%20with%20welcome%20sign%20professional%20transfer%20service%20driver%20waiting%20for%20passenger%20modern%20european%20airport%20terminal%20bright%20clean%20environment&width=600&height=400&seq=svc-havalimani-001&orientation=landscape',
  },
  {
    id: 'education-package',
    icon: 'ri-graduation-cap-line',
    title: 'Eğitim Danışmanlığı Paketi',
    description: 'Lisans, yüksek lisans ve dil okulu başvuru süreçlerinde kapsamlı danışmanlık',
    details: [
      'Üniversite ve program araştırması',
      'Başvuru belgelerinin hazırlanması',
      'Motivasyon mektubu desteği',
      'CV hazırlama',
      'Üniversite başvuru takibi',
      'Oryantasyon desteği'
    ],
    price: '€2.000',
    duration: '3-6 ay',
    image: 'https://readdy.ai/api/search-image?query=professional%20education%20consultant%20meeting%20with%20international%20student%20in%20modern%20office%20discussing%20university%20application%20documents%20academic%20planning%20warm%20lighting%20contemporary%20interior&width=600&height=400&seq=svc-egitim-001&orientation=landscape',
  },
];

const visaDocuments = [
  'Geçerli pasaport',
  'Üniversite kabul mektubu',
  'Bloke hesap belgesi',
  'Sağlık sigortası belgesi',
  'Diploma ve transkript',
  'Dil yeterlilik belgesi',
  'Motivasyon mektubu',
  'CV',
  'Vize başvuru formu'
];

export default function ServicesPage() {
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const navigate = useNavigate();

  const handleGetService = () => {
    setSelectedService(null);
    navigate('/contact');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-[#1a1a1a] text-white py-24">
        <div className="absolute inset-0">
          <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#DD0000]/10 rounded-full blur-[120px]"></div>
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#FFCE00]/8 rounded-full blur-[100px]"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Hizmetlerimiz
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
              Almanya&apos;da eğitim sürecinizin her aşamasında ihtiyaç duyacağınız tüm hizmetler için yanınızdayız
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a
                href="#services"
                className="px-8 py-4 bg-[#FFCE00] text-[#1a1a1a] font-semibold rounded-lg hover:bg-[#e6b800] transition-all whitespace-nowrap cursor-pointer"
              >
                Hizmetleri İncele
              </a>
              <button
                type="button"
                disabled
                className="px-8 py-4 bg-[#25D366]/50 text-white font-semibold rounded-lg whitespace-nowrap cursor-default flex items-center gap-2"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                WhatsApp
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section id="services" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Tüm Hizmetlerimiz
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Almanya&apos;da eğitim hayatınızı kolaylaştıracak profesyonel destek hizmetleri
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden cursor-pointer group"
                onClick={() => setSelectedService(service)}
              >
                {/* Image Header */}
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-4 left-4 right-4">
                    <h3 className="text-xl font-bold text-white">{service.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-gray-600 mb-6 text-sm">
                    {service.description}
                  </p>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center text-[#DD0000]">
                      <i className="ri-price-tag-3-line mr-2"></i>
                      <span className="font-bold text-lg">{service.price}</span>
                    </div>
                    {service.duration && (
                      <div className="flex items-center text-gray-500">
                        <i className="ri-time-line mr-2"></i>
                        <span className="text-sm">{service.duration}</span>
                      </div>
                    )}
                  </div>
                  <button className="w-full px-6 py-3 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer">
                    Detayları Görüntüle
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Konaklama Fiyat Tablosu */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Konaklama Seçenekleri ve Fiyatları
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Almanya&apos;da güvenli ve uygun fiyatlı konaklama bulmanıza yardımcı oluyoruz
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-building-line',
                title: 'Öğrenci Yurdu',
                price: '€400 - €800/ay',
                features: ['En ekonomik seçenek', 'Kampüse yakın', 'Sosyal ortam', 'Faturalar dahil', 'Ortak mutfak ve banyo'],
                image: 'https://readdy.ai/api/search-image?query=modern%20student%20dormitory%20room%20in%20germany%20with%20single%20bed%20desk%20and%20bookshelf%20clean%20minimalist%20design%20bright%20natural%20light%20shared%20living%20space&width=500&height=350&seq=konak-yurt-001&orientation=landscape',
              },
              {
                icon: 'ri-home-smile-line',
                title: 'Öğrenci Evi (WG)',
                price: '€400 - €800/ay',
                features: ['Popüler seçenek', 'Özel oda', 'Ortak alanlar', 'Sosyal yaşam', 'Esnek kira süreleri'],
                image: 'https://readdy.ai/api/search-image?query=shared%20student%20flat%20WG%20in%20berlin%20germany%20with%20common%20kitchen%20area%20young%20people%20living%20together%20modern%20european%20apartment%20cozy%20atmosphere%20warm%20lighting&width=500&height=350&seq=konak-wg-001&orientation=landscape',
              },
              {
                icon: 'ri-home-4-line',
                title: 'Özel Daire',
                price: '€700 - €1.200/ay',
                features: ['Tam bağımsızlık', 'Özel mutfak ve banyo', 'Sessiz ortam', 'Uzun dönem için ideal', 'Mobilyalı/mobilyasız'],
                image: 'https://readdy.ai/api/search-image?query=private%20modern%20apartment%20in%20german%20city%20with%20full%20kitchen%20bathroom%20and%20living%20room%20contemporary%20furniture%20bright%20spacious%20interior%20warm%20natural%20lighting&width=500&height=350&seq=konak-ozel-001&orientation=landscape',
              },
            ].map((option, index) => (
              <div key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-xl transition-all">
                <div className="relative w-full h-48 overflow-hidden">
                  <img src={option.image} alt={option.title} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <h3 className="text-xl font-bold text-white">{option.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <div className="text-center mb-4">
                    <span className="text-2xl font-bold text-[#DD0000]">{option.price}</span>
                  </div>
                  <ul className="space-y-2">
                    {option.features.map((feature, idx) => (
                      <li key={idx} className="flex items-start">
                        <i className="ri-checkbox-circle-fill text-green-600 mr-2 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vize Süreci */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Vize Başvuru Süreci
              </h2>
              <p className="text-lg text-gray-600 mb-8">
                Almanya öğrenci vizesi başvurusu karmaşık bir süreç olabilir. Rota Berlin olarak tüm adımlarda size rehberlik ediyoruz.
              </p>
              <div className="space-y-4">
                {[
                  { step: '1', title: 'Belge Hazırlığı', desc: 'Gerekli tüm belgeleri topluyoruz' },
                  { step: '2', title: 'Randevu Alma', desc: 'Konsolosluk randevusu alıyoruz' },
                  { step: '3', title: 'Form Doldurma', desc: 'Başvuru formlarını hazırlıyoruz' },
                  { step: '4', title: 'Görüşme Hazırlığı', desc: 'Vize görüşmesi için hazırlık yapıyoruz' },
                  { step: '5', title: 'Başvuru Takibi', desc: 'Başvurunuzu takip ediyoruz' },
                ].map((item, index) => (
                  <div key={index} className="flex items-start">
                    <div className="w-12 h-12 bg-[#DD0000] rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold text-lg">{item.step}</span>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">{item.title}</h3>
                      <p className="text-gray-600">{item.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Gerekli Belgeler</h3>
              <ul className="space-y-3">
                {visaDocuments.map((doc, index) => (
                  <li key={index} className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-green-600 mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                    <span className="text-gray-700">{doc}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 p-4 bg-[#FFCE00]/10 border border-[#FFCE00]/30 rounded-lg">
                <div className="flex items-start">
                  <i className="ri-information-line text-[#DD0000] mr-3 mt-1"></i>
                  <p className="text-sm text-gray-700">
                    <strong>Not:</strong> Vize başvuru süresi ortalama 6-12 hafta sürmektedir. Erken başvuru yapmanızı öneririz.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Hizmet Paketleri Karşılaştırma */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Bireysel Hizmetler</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              İhtiyacınıza göre tek tek hizmet seçebilirsiniz
            </p>
          </div>

          <div className="max-w-2xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Hizmet Fiyatları</h3>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Bloke Hesap</span>
                  <span className="font-bold text-[#DD0000]">€300</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Sağlık Sigortası</span>
                  <span className="font-bold text-[#DD0000]">€200</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">İndirimli Konaklama</span>
                  <span className="font-bold text-[#DD0000]">€400 - €600</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Havalimanı Karşılama</span>
                  <span className="font-bold text-[#DD0000]">€350</span>
                </li>
                <li className="flex items-center justify-between">
                  <span className="text-gray-700">Eğitim Danışmanlığı Paketi</span>
                  <span className="font-bold text-[#DD0000]">€2.000</span>
                </li>
              </ul>
              <div className="border-t pt-6">
                <Link
                  to="/contact"
                  className="block w-full px-6 py-3 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all text-center whitespace-nowrap cursor-pointer"
                >
                  Hizmet Seç
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Sık Sorulan Sorular</h2>
          </div>
          <div className="max-w-4xl mx-auto space-y-6">
            {[
              {
                question: 'Bloke hesap için ne kadar para yatırmam gerekiyor?',
                answer: '2024 yılı için Almanya öğrenci vizesi için minimum 12.000 € bloke hesaba yatırılması gerekmektedir. Bu tutar yıllık yaşam masraflarınızı karşılamak için belirlenen minimum tutardır.',
              },
              {
                question: 'Sağlık sigortası ne zaman başlatmalıyım?',
                answer: 'Sağlık sigortanızı Almanya\'ya gelmeden önce başlatmanız gerekmektedir. Vize başvurusu için sigorta belgesi zorunludur.',
              },
              {
                question: 'Konaklama aramaya ne zaman başlamalıyım?',
                answer: 'Konaklama aramaya kabul mektubunuzu aldıktan sonra en az 2-3 ay önceden başlamanızı öneririz.',
              },
              {
                question: 'Eğitim danışmanlığı paketi ne kadar sürede tamamlanır?',
                answer: 'Eğitim danışmanlığı paketimiz ortalama 3-6 ay sürmektedir. Bu süre üniversite başvurusu, kabul mektubu, vize süreci ve diğer hazırlıkları kapsar.',
              },
            ].map((faq, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#1a1a1a] text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Almanya Yolculuğunuza Başlayın</h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Rota Berlin olarak tüm süreçlerde yanınızdayız. Ücretsiz danışmanlık için hemen iletişime geçin.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/contact"
              className="px-8 py-4 bg-[#FFCE00] text-[#1a1a1a] font-semibold rounded-lg hover:bg-[#e6b800] transition-all whitespace-nowrap cursor-pointer"
            >
              Ücretsiz Danışmanlık
            </Link>
            <a
              href="mailto:rotaberlinn@gmail.com"
              className="px-8 py-4 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-mail-line text-2xl"></i>
              E-posta Gönder
            </a>
          </div>
        </div>
      </section>

      {/* Service Detail Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-6" onClick={() => setSelectedService(null)}>
          <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            {/* Modal Header with Image */}
            <div className="relative w-full h-56 overflow-hidden rounded-t-2xl">
              <img src={selectedService.image} alt={selectedService.title} className="w-full h-full object-cover object-top" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
              <div className="absolute bottom-6 left-6 right-6">
                <h2 className="text-3xl font-bold text-white">{selectedService.title}</h2>
              </div>
              <button
                onClick={() => setSelectedService(null)}
                className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full hover:bg-white/40 transition-all cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-white"></i>
              </button>
            </div>

            <div className="p-8">
              <p className="text-lg text-gray-700 mb-8">{selectedService.description}</p>

              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-gray-50 rounded-xl p-6 text-center">
                  <i className="ri-price-tag-3-line text-4xl text-[#DD0000] mb-3"></i>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Ücret</h3>
                  <p className="text-2xl font-bold text-[#DD0000]">{selectedService.price}</p>
                </div>
                {selectedService.duration && (
                  <div className="bg-gray-50 rounded-xl p-6 text-center">
                    <i className="ri-time-line text-4xl text-[#FFCE00] mb-3"></i>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Süre</h3>
                    <p className="text-gray-700 text-lg">{selectedService.duration}</p>
                  </div>
                )}
              </div>

              <div className="mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Hizmet Detayları</h3>
                <ul className="space-y-3">
                  {selectedService.details.map((detail, index) => (
                    <li key={index} className="flex items-start">
                      <i className="ri-checkbox-circle-fill text-green-600 mr-3 mt-1 w-5 h-5 flex items-center justify-center"></i>
                      <span className="text-gray-700">{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex gap-4">
                <button
                  onClick={handleGetService}
                  className="flex-1 px-6 py-4 bg-[#DD0000] text-white font-semibold rounded-lg hover:bg-[#bb0000] transition-all text-center whitespace-nowrap cursor-pointer"
                >
                  Hizmeti Al
                </button>
                <a
                  href="mailto:rotaberlinn@gmail.com"
                  className="flex-1 px-6 py-4 bg-[#1a1a1a] text-white font-semibold rounded-lg hover:bg-gray-800 transition-all text-center whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-mail-line text-xl"></i>
                  E-posta
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
